import React, { Component } from 'react';
import StaticPage from '../StaticPage';
import PageHeader from '../../components/PageHeader';
import localize from '../../components/localize';
import { NavLink, Route } from 'react-router-dom';
import classNames from 'classnames';
import FooterButton from '../../components/FooterButton';

const imagePaths = require.context('./images/animations', true);

import './Lag.css';

export default localize('pages.lag')(({ i18n, match }) => {
	const topSections = ['latency', 'packet_loss', 'jitter', 'bandwidth'].map((section) => ( <CopyBlock i18nPath={i18n.path(section)} key={section} section={section} imageAlign='left' /> ));
	const bottomSections = ['network_connection', 'behind_the_scenes', 'sync', 'lag_wtf'].map((section) => ( <CopyBlock i18nPath={i18n.path(section)} section={section} key={section} imageAlign='right' />));

	return (
				  <StaticPage i18nPath={i18n.path()}>
            <div className="centered-content">
              <div className="centered-content">
                <VideoBlock i18nPath={i18n.path('pressing_q')} />
              </div>

              {topSections}
            </div>
            <TabSet i18nPath={i18n.path('tabset')} tabs={['player-computer', 'home-network', 'isp', 'internet-backbone', 'game-servers']} urlPrefix={match.url} />

            <PageHeader i18nPath={i18n.path('lag_demystified')} />

            <div className="centered-content">
              <CopyBlock i18nPath={i18n.path('what_is_lag')} section='what_is_lag' key='what_is_lag' alwaysShowVideo={true} imageAlign='right' />

              {bottomSections}

              <FooterButton i18nPath={i18n.path('buttons.got_lag')} dest="/steps" />
            </div>
					</StaticPage>
				 );
});

const VideoBlock = localize()(({ i18n, className = '' }) => {
  const classes = classNames('video-block', className);

  return (
      i18n.has('video_url') && <section className={classes}>
        <div className="content">
          <div className="video">
            <iframe width="100%" height="60%" src={i18n.t('video_url')} frameBorder="0" allowFullScreen />
          </div>
        </div>
        <hr className="centered" />
      </section>
    )
});

const CopyBlock = localize()(({ i18n, imageAlign, className, section, alwaysShowVideo = false }) => {
	const classes = classNames('copy-block', i18n.has('caption') && `image-${imageAlign}`, section, className);
	return (<section className={classes}>
						{(i18n.has('caption') || alwaysShowVideo) && <VideoWithCaption section={section} caption={i18n.has('caption') && i18n.t('caption')} />}
						<div className="content">
							<h2>{i18n.t('header')}</h2>
							<p dangerouslySetInnerHTML={{ __html: i18n.t('body')}} />
						</div>
					</section>);
});

const TabSet = localize()(({ i18n, i18nPath, tabs, urlPrefix }) => {
  const tabUrl = (tab, index) => {
    return index > 0 ? `/tabs/${tab}` : '';
  }

	return (
		<div className="tabset">
			<div className="centered-content"><CopyBlock i18nPath={i18nPath} /></div>

			<div className="centered-content">
	      <q-nav justify="center">
	        {tabs.map((tab, i) => <NavLink to={`${urlPrefix}${tabUrl(tab, i)}`} exact key={tab} className={`icon ${tab}`}>{i18n.t(`tabs.${tab}.header`)}</NavLink>)}
	      </q-nav>
			</div>

      <div className="centered-content">
        <div className="tab-content">
    			{tabs.map((tab, i) => <Route path={`${urlPrefix}${tabUrl(tab, i)}`} key={tab} exact render={() => <div dangerouslySetInnerHTML={{__html: i18n.t(`tabs.${tab}.body`)}} />} />)}
        </div>
      </div>
		</div>
	);
});

class VideoWithCaption extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: false
    };
  }

  handleClick() {
    this.setState({
      playing: !this.state.playing
    });

    this.state.playing ?
      this.videoEl.pause() :
      this.videoEl.play();
  }

  render() {
    const { caption, section } = this.props;

    return <figure>
              <video ref={videoEl => this.videoEl = videoEl} loop={true} src={imagePaths('./' + section + '.mp4', true)} poster={imagePaths('./' + section + '.png', true)} alt={caption} onClick={() => this.handleClick()} className="animated" />
              <figcaption>{caption}</figcaption>
            </figure>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/Lag/index.js